import { Box, Card, Stack, Typography } from '@mui/material';
import { AsyncSelect, Icon, theme } from 'bs-unified-ui';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { State } from 'country-state-city';
import { Field } from '~/components/common/Formik2';
import {
  POS_TYPE_OPTIONS,
  PROVINCE_TYPE_OPTIONS,
  PROVINCE_TYPE,
} from '~/constants';
import { useAnnouncementDetailContext } from '../AnnouncementDetailContext';

const ApplyToClientsSection = () => {
  const { values, setFieldValue } = useFormikContext<any>();
  const { isArchived } = useAnnouncementDetailContext();

  const { apply_to_provinces = [] } = values;

  const provinces = useMemo(() => {
    const canadaStates = State.getStatesOfCountry('CA');
    return (
      canadaStates.map((state) => ({
        value: state.isoCode,
        label: state.name,
      })) || []
    );
  }, []);

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        pointerEvents: isArchived ? 'none' : 'auto',
        color: theme.foreground.black,
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 18,
        }}
      >
        Apply to clients
      </Typography>
      <Box
        flexDirection='column'
        display='flex'
        color={theme.foreground.black}
        gap={0.5}
      >
        <Typography variant='fs14'>POS type</Typography>
        <Field.Radio
          formControlSx={{
            'width': '100%',
            '& .MuiFormControlLabel-root': {
              alignItems: 'start',
              mr: 0,
            },
            '& .MuiRadio-root': { p: '4px 10px' },
            '& .MuiFormControlLabel-label': { flex: 1 },
          }}
          name='apply_to_pos'
          options={POS_TYPE_OPTIONS}
        />
      </Box>
      <Box
        flexDirection='column'
        display='flex'
        color={theme.foreground.black}
        gap={0.5}
      >
        <Typography variant='fs14'>Provinces</Typography>
        <Field.Radio
          formControlSx={{
            'width': '100%',
            '& .MuiFormControlLabel-root': {
              alignItems: 'start',
              mr: 0,
            },
            '& .MuiRadio-root': { p: '4px 10px' },
            '& .MuiFormControlLabel-label': { flex: 1 },
          }}
          name='apply_to_provinces_type'
          options={PROVINCE_TYPE_OPTIONS}
        />
        <AsyncSelect
          label=''
          value={apply_to_provinces}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          options={provinces?.filter(
            (x) => !apply_to_provinces?.find((y: any) => x.value === y.value),
          )}
          onSearchBoxChange={(_, v) => {
            setFieldValue('apply_to_provinces', v);
          }}
          popupIcon
          multiple
          disabled={values.apply_to_provinces_type === PROVINCE_TYPE.ALL}
          sx={{
            '& .MuiButtonBase-root': {
              'display': 'none',
              'marginLeft': '4px !important',
              'paddingRight': '8px !important',
              '& > span': {
                padding: '0px 8px 0px 10px',
              },
            },
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
              padding: '2px',
            },
          }}
        />
        {values.apply_to_provinces_type === PROVINCE_TYPE.SPECIFIC && (
          <Stack
            sx={{
              mt: 1,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
            {apply_to_provinces?.map((province) => (
              <Box
                key={province.value}
                sx={{
                  px: 1,
                  py: 0.5,
                  backgroundColor: '#F1F1F2',
                  borderRadius: '4px',
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 1,
                  alignItems: 'center',
                }}
              >
                <Typography variant='fs12'>{province.label}</Typography>
                <Box
                  sx={{
                    cursor:
                      values.apply_to_provinces_type === PROVINCE_TYPE.ALL
                        ? 'not-allowed'
                        : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    if (values.apply_to_provinces_type === PROVINCE_TYPE.ALL) {
                      return;
                    }
                    const updatedProvinces = apply_to_provinces.filter(
                      (p: any) => p.value !== province.value,
                    );
                    setFieldValue('apply_to_provinces', updatedProvinces);
                  }}
                >
                  <Icon name='close' size={8} color='rgba(51, 54, 61, 0.40)' />
                </Box>
              </Box>
            ))}
          </Stack>
        )}
      </Box>
    </Card>
  );
};

export default ApplyToClientsSection;
